import { Company } from "../models/Company";
import { InstructionKey } from "../models/InstructionKey";
import { Po } from "../models/Po";
import { ResponseObject } from "../models/ResponseObject";
import { VendorRequestChangeData } from "../models/VendorRequestChange/VendorRequestChangeData";
import { VendorDetailState } from "../reducers/vendor/VendorDetailReducer";
import { AxiosConfig } from "./AxiosConfig";

const getCompany = async (
  vendorId: number,
  successCallback: (companyData: Array<Company>) => void,
  errorCallback: (error: Error) => void
) => {
  try {
    const resp = await AxiosConfig.get(
      `/VendorAmendment/GetCoCodesToAmend?vendorNo=${vendorId}`
    );
    successCallback(resp.data);
  } catch (err: any) {
    // Handle Error Here
    console.error(err);
    errorCallback(err);
  }
};

const getPO = async (
  vendorId: number,
  companyCode: string,
  successCallback: (poData: Array<Po>) => void,
  errorCallback: (error: Error) => void
) => {
  try {
    const resp = await AxiosConfig.get(
      `/VendorAmendment/GetPoCodesToAmend?vendorNo=${vendorId}&coCode=${companyCode}`
    );
    successCallback(resp.data);
  } catch (err: any) {
    // Handle Error Here
    console.error(err);
    errorCallback(err);
  }
};

const getInstructionKeyData = async (
  countryCode: string,
  successCallback: (instructionKeyData: Array<InstructionKey>) => void,
  errorCallback: (error: Error) => void
) => {
  try {
    const resp = await AxiosConfig.get(
      `/VendorAmendment/GetInstructionKeyData?countryCode=${countryCode}`
    );
    successCallback(resp.data);
  } catch (err: any) {
    // Handle Error Here
    console.error(err);
    errorCallback(err);
  }
};

// const getVendorAmendDetailData = async (
//   id: number,
//   successCallback: (getVendorData: VendorDetailState) => void,
//   errorCallback: (error: Error) => void
// ) => {
//   try {
//     const resp = await AxiosConfig.get(
//       `VendorAmendment/GetForm2Data?requestId=${id}`
//     );
//     successCallback(resp.data);
//   } catch (err: any) {
//     // Handle Error Here
//     console.error(err);
//     errorCallback(err);
//   }
// };

const submitVendorAmendRequest = async (
  vendorAmendSubmitData: VendorRequestChangeData,
  successCallback: (vendorBlockData: any) => void,
  errorCallback: (error: Error) => void
) => {
  try {
    const resp = await AxiosConfig.post(
      "/VendorAmendment/AmendVendor",
      vendorAmendSubmitData
    );
    successCallback(resp.data);
  } catch (err: any) {
    // Handle Error Here
    console.error(err);
    errorCallback(err);
  }
};

const updateVendor = async (
  updateVendorData: VendorDetailState,
  successCallback: (vendorData: ResponseObject) => void,
  errorCallback: (error: Error) => void
) => {
  try {
    const resp = await AxiosConfig.post(
      "/VendorAmendment/SaveForm2",
      updateVendorData
    );
    successCallback(resp.data);
  } catch (err: any) {
    // Handle Error Here
    console.error(err);
    errorCallback(err);
  }
};

const submitVendor = async (
  requestId: number,
  successCallback: (vendorData: ResponseObject) => void,
  errorCallback: (error: Error) => void
) => {
  try {
    const resp = await AxiosConfig.post(
      "/VendorAmendment/SubmitRequest",
      requestId
    );
    successCallback(resp.data);
  } catch (err: any) {
    // Handle Error Here
    console.error(err);
    errorCallback(err);
  }
};

export const VendorAmendService = {
  updateVendor,
  //getVendorAmendDetailData,
  getInstructionKeyData,
  getCompany,
  getPO,
  submitVendorAmendRequest,
  submitVendor
};
